// libs
import { connect } from 'react-redux';

// redux
import {
  getProductBrandUrl,
  getProductId,
  getBadge,
  getDisclaimerText,
  getModelWidgetData,
  getProductData,
  getColorOptions,
  getDefaultColor,
  isOneSize,
  getTags,
  getCategoryLevel,
  getIsProductOffersAvailable,
  getIsOffersFetching,
  getValidProductOffers,
  getProductSizeOptions,
  getBrandBook,
} from 'shared/store/details/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';
import { onIntlNetwork } from 'shared/store/app/selectors/international';

// helpers
import { getWishlistEnabled } from 'shared/components/Wishlist/helper';

// components
import Desktop from './Desktop';

const mapStateToProps = (state: any) => {
  const { type, categoryName } = getProductData(state);
  return {
    brandUrl: getProductBrandUrl(state),
    productID: getProductId(state),
    badge: getBadge(state),
    disclaimer: getDisclaimerText(state),
    onIntlNetwork: onIntlNetwork(state),
    modelData: getModelWidgetData(state),
    priceRevealConfig: getRemoteConfig(state, 'priceReveal'),
    type,
    categoryName,
    colorOptions: getColorOptions(state),
    defaultColor: getDefaultColor(state),
    isOneSize: isOneSize(state),
    isWishlistEnabled: getWishlistEnabled(getRemoteConfig(state, 'wishlist')).desktop,
    tags: getTags(state),
    categoryLevels: getCategoryLevel(state),
    isProductOffersAvailable: getIsProductOffersAvailable(state),
    productOffers: getValidProductOffers(state),
    isOffersFetching: getIsOffersFetching(state),
    newEcomFetchApiEnabled: getRemoteConfig(state, 'enableNewFetchApiOnDesktop'),
    sizeOptions: getProductSizeOptions(state),
    brandBookData: getBrandBook(state),
  };
};

export default connect(mapStateToProps)(Desktop);
